import React from "react";
import { Storage } from "aws-amplify";
var uuidv1 = require('uuid/v1');

export const convertImageAttributes = (content) => {

    //console.log("***** GET IMAGE ATTRIBUTES *****");
    //var sampleimg = "https://www.dike.lib.ia.us/images/sample-1.jpg";
    //exanple: new_content_obj.entityMap = JSON.parse('{"0":{"type":"IMAGE","mutability":"MUTABLE","data":{"src":"'+sampleimg+'","height": "400px","width": "auto"}},"1": {"data": {}},"2": {"data": {}}}');

    let tmp_img_src_arr   = [];
    let tmp_img_data_arr  = [];

    let tmp_obj           = {};

    if(content != undefined) {
        let entityMap = content.entityMap;

        //console.log("blocks: " + content.blocks);
        //console.log("parse: " + JSON.parse(content.blocks));

        /////////////////////////////////////////////
        ////   GET EXISTING IMAGES FROM EDITOR   ////
        for(var key in entityMap) {

                var type = entityMap[key].type;

                if(type === "IMAGE") {
                    var src       = entityMap[key].data.src;
                    var height    = entityMap[key].data.height;
                    var width     = entityMap[key].data.width;
                    var alignment = entityMap[key].data.alignment;

                    //////////////////////////////////////////////////////////////////////////////////////
                    // EXTRACT IMAGE ID FROM EXPIRED AWS URL so we can get new ACCESS KEY FOR IMAGE URL //
                    // STEP 1. REMOVE ACCESS KEY STRING
                    var aws_index = src.indexOf('?AWSAccessKeyId=');
                    //console.log("aws_index: " + aws_index);

                    if(aws_index > 0) {
                            var url_sub = src.substr(0, aws_index);

                            ///////////////////////////////////////////////////////////
                            //   STEP 2. EXTRACT RAW IMAGE ID FROM AWS S3's URL      //
                            //   REMOVE ANYTHING BEFORE LAST "/" to get IMAGE ID     //
                            var num = url_sub.lastIndexOf('/');
                            var img_id = url_sub.substring(num + 1);

                            //console.log("Src: " + src);
                            //console.log("AWS Img Id: " + img_id);

                            tmp_img_src_arr.push(img_id)
                            tmp_img_data_arr.push([height, width, alignment]);
                    }
                }
        }
    }

    tmp_obj.tmp_img_src_arr = tmp_img_src_arr;
    tmp_obj.tmp_img_data_arr= tmp_img_data_arr;

    return tmp_obj;
}

export const compareExistingToNewImages = async (existing_images_arr, new_images_arr) => {
        //console.log("1. Existing Editor Images: " + existing_images_arr);
        //console.log("2. NEW Editor Images: " + new_images_arr);/* */

        //////////////////////////////////////////////////////////
        //   Step 1. REMOVE S3 Images THAT ARE NO LONGER USED   //

        var lgth  = existing_images_arr.length;
        var lgth2 = new_images_arr.length;
        if(lgth2 > lgth) lgth = lgth2; // loop through the array with the most elements

        // Compare Arrays and remove the images that were deleted
        for(var i=0; i < lgth; i++) {
            var new_img = new_images_arr[i];
            if(new_img != "") {
                var index = existing_images_arr.indexOf(new_img);

                if(index != -1) {
                    // Remove any images which still exist in the editor, those images do not need to be deleted
                    existing_images_arr.splice( existing_images_arr.indexOf(new_img), 1 );
                }
            }
        }

        // REMOVE ANY NULL/EMPTY ELEMENTS FROM ARRAY BEFORE DELETING THEM FROM AWS S3 //
        var filtered_arr = existing_images_arr.filter(Boolean)

        // Images Need to be deleted from the Database
        return await deleteAWSImageArr(filtered_arr).then(function(value) {
                return true;
        })
}


export const parseJsonForImages = async (content) => {
    //console.log("-------------- BEGIN Parse JSON ----------------");

    var new_content_obj = {};
    new_content_obj = content;

    if(content != null || content != undefined) {
        // min load content blocks into "new_content_obj"
        //new_content_obj.blocks    = content.blocks;
        //new_content_obj.entityMap = content.entityMap;

        // Debug: READ JSON CONTENT - console.log( JSON.stringify(content, null, "    ") )

        let current_images_arr = [];//this.state.currentEditorImages;

        let tmp_obj          = convertImageAttributes(content);
        let tmp_img_src_arr  = tmp_obj.tmp_img_src_arr;
        let tmp_img_data_arr = tmp_obj.tmp_img_data_arr;
        let other_img_src_arr= tmp_obj.other_img_src_arr;

        //////////////////////////////////////////////////////////
        ////   ADD NEW AWS S3 IMG SRC BACK INTO JSON FORMAT   ////
        ////   so the React Draft Editor can read the data    ////
        return await processAWSImageArr(tmp_img_src_arr).then(function(value) {
                let tmp_lgth = value.length;
                let entity = "";

                for(var i=0; i < tmp_lgth; i++) {
                    var height = tmp_img_data_arr[i][0];
                    var width  = tmp_img_data_arr[i][1];
                    var alignment = tmp_img_data_arr[i][2];

                    if(alignment === undefined) alignment = "none"

                    entity += '"'+i+'":{"type":"IMAGE","mutability":"MUTABLE","data":{"src":"'+value[i]+'","height": "'+height+'","width": "'+width+'","alignment": "'+alignment+'"}}';
                    if(tmp_lgth > 0) entity += ',';
                }

                // Add corresponding empty data objects that are associated to above
                // images for proper JSON format
                var tmp_lgth2 =  (tmp_lgth*2)-1;

                for(var i=tmp_lgth; i < tmp_lgth*2; i++) {
                    entity += '"'+ i +'": {"data": {}}';
                    if(i < tmp_lgth2) entity += ',';
                }

                //simple JSON example: new_content_obj.entityMap = JSON.parse('{'+entity+',"1": {"data": {}},"2": {"data": {}},"3": {"data": {}}}');
                new_content_obj.entityMap = JSON.parse('{'+entity+'}');
                new_content_obj.img_src_arr = tmp_img_src_arr;
                return new_content_obj;
        });
    } else {
        //new_content_obj = content;
        //return content;
    }
}

export const processAWSImageArr = async (array) => {
    const promises = array.map(getAWSImageURL);
    // wait until all promises are resolved
    return  await Promise.all(promises);
}


// STEP 3. GET NEW IMAGE URL WITH PROPER ACCESS PERMISSIONS
export const getAWSImageURL = async (image_id) => {
    return await Storage.vault.get(image_id); //save attach url in db
}

//// DELETE S3 IMAGES ////
export const deleteAWSImageArr = async (array) => {
    const promises = array.map(deleteS3Image);
    // wait until all promises are resolved
    return  await Promise.all(promises);
}

export const deleteS3Image = async (image_id) => {
    return await Storage.vault.remove(image_id); //save attach url in db
}



// WEBPACK FOOTER //
// ./src/screens/assessment/utils.js